// extracted by mini-css-extract-plugin
module.exports = {"buyWithApplePayBtn":"styles_base_buyWithApplePayBtn__XzaDe"};